import { useLocation, useNavigate, Link } from "react-router-dom";
import { 
  Home, 
  Calendar, 
  Search, 
  User, 
  Gift,
  Scissors,
  BarChart3,
  Settings,
  Users,
  Clock,
  BookOpen,
  MessageSquare,
  ArrowLeft
} from "lucide-react";
import { cn } from "@/lib/utils";

const MobileBottomNav = ({ userRole = "client", showBackButton = false, backPath = "/" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Define nav items based on user role
  const getNavItems = () => {
    if (userRole === "client") {
      return [
        { icon: Home, label: "Home", path: "/dashboard" },
        { icon: Search, label: "Find", path: "/find-stylists" },
        { icon: Calendar, label: "Book", path: "/book" },
        { icon: Gift, label: "Rewards", path: "/dashboard", tab: "loyalty" },
        { icon: BookOpen, label: "Help", path: "/user-guide", query: "?role=client" }
      ];
    }
    
    if (userRole === "stylist" || userRole === "owner") {
      return [
        { icon: Home, label: "Home", path: "/stylist" },
        { icon: Calendar, label: "Schedule", path: "/stylist", tab: "schedule" },
        { icon: Users, label: "Clients", path: "/stylist", tab: "clients" },
        { icon: BarChart3, label: "Revenue", path: "/stylist", tab: "analytics" },
        { icon: BookOpen, label: "Help", path: "/user-guide", query: "?role=stylist" }
      ];
    }

    // Guest/unauthenticated users
    return [
      { icon: Home, label: "Home", path: "/" },
      { icon: Search, label: "Find", path: "/find-stylists" },
      { icon: Calendar, label: "Book", path: "/book" },
      { icon: User, label: "Login", path: "/login" },
      { icon: BookOpen, label: "Help", path: "/user-guide" }
    ];
  };
  
  const navItems = getNavItems();
  
  const isActive = (item) => {
    if (item.query) {
      return location.pathname === item.path;
    }
    if (item.tab) {
      return location.pathname === item.path;
    }
    return location.pathname === item.path;
  };
  
  const handleNavClick = (item) => {
    if (item.query) {
      navigate(item.path + item.query);
    } else if (item.tab) {
      navigate(item.path, { state: { activeTab: item.tab } });
    } else {
      navigate(item.path);
    }
  };
  
  return (
    <nav className="mobile-bottom-nav" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around">
        {showBackButton && (
          <button
            onClick={() => navigate(backPath)}
            className="mobile-nav-item flex-1 tap-highlight"
            data-testid="mobile-nav-back"
          >
            <ArrowLeft className="w-6 h-6 text-gray-500" />
            <span className="text-gray-500">Back</span>
          </button>
        )}
        {navItems.map((item) => (
          <button
            key={item.label}
            onClick={() => handleNavClick(item)}
            className={cn(
              "mobile-nav-item flex-1 tap-highlight",
              isActive(item) && "active"
            )}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
          >
            <item.icon 
              className={cn(
                "w-6 h-6 transition-all duration-200",
                isActive(item) ? "text-amber-400 scale-110" : "text-gray-500"
              )} 
            />
            <span className={cn(
              "transition-colors duration-200",
              isActive(item) ? "text-amber-400" : "text-gray-500"
            )}>
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
